export class BusinessHoursTimeModel {
  timeString: string;
  time24String: string;
  viewTimeString: string;
  viewTime24String: string;
  hour: number;
  minutes: string;
  demarcation: string;
  hour24: number;
}
